import { render } from "./RegisterUserPage.vue?vue&type=template&id=182ca843&ts=true"
import script from "./RegisterUserPage.vue?vue&type=script&lang=ts"
export * from "./RegisterUserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__